<template>
  <div class="text-indigo-600 bg-indigo-200 border-opacity-20 border-indigo-600 border-2 rounded-md px-5 py-3">
    <slot />
  </div>    
</template>

<script>
export default {
    
};
</script>